import React, { ReactElement } from "react"
import { Trans } from "@lingui/macro"
import PhoneNumber from "../PhoneNumber/PhoneNumber"
import styles from "./CreateQuoteBox.module.scss"
import ErrorBox from "./ErrorBox"

type Props = {
    onButtonClick: () => void
    buttonLabel: string | ReactElement
}

const CreateQuoteBox: React.FC<React.PropsWithChildren<Props>> = ({ buttonLabel, onButtonClick }) => {
    return (
        <ErrorBox
            button={{
                label: buttonLabel,
                onClick: onButtonClick,
            }}
            message={
                <>
                    <p className={styles.message}>
                        <Trans>
                            We&apos;re sorry there has been an issue creating your quote. Please try to personalize your
                            quote again. If the problem persists, we invite you to contact our Reservation Team directly
                            at
                        </Trans>
                    </p>
                    <PhoneNumber className={styles.phoneNumber} />
                </>
            }
        ></ErrorBox>
    )
}

export default CreateQuoteBox
